import { render } from "./hub-toolbar.vue?vue&type=template&id=4325bf24&scoped=true"
import script from "./hub-toolbar.vue?vue&type=script&lang=js"
export * from "./hub-toolbar.vue?vue&type=script&lang=js"

import "./hub-toolbar.vue?vue&type=style&index=0&id=4325bf24&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4325bf24"]])

export default __exports__